/*!
// ##############################
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################
*/

import { width } from '@mui/system';

const hexToRgb = input => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return (
    parseInt(first, 16) +
    ', ' +
    parseInt(second, 16) +
    ', ' +
    parseInt(last, 16)
  );
};

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const drawerWidth = 260;

const transition = {
  transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
};

const container = {
  paddingRight: '0px',
  paddingLeft: '0px',
  marginRight: 'auto',
  marginLeft: 'auto'
};

const defaultFont = {
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: '300',
  lineHeight: '1.5em'
};

const primaryColor = ['#837e84', '#3674a2', '#07273e', '#af2cc5'];
const warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a'];
const dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e'];
const successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860'];
const infoColor = ['#00acc1', '#26c6da', '#00acc1', '#00d3ee'];
const roseColor = ['#e91e63', '#ec407a', '#d81b60', '#eb3573'];
const grayColor = [
  '#999',
  '#777',
  '#3C4858',
  '#AAAAAA',
  '#D2D2D2',
  '#DDD',
  '#b4b4b4',
  '#555555',
  '#333',
  '#a9afbb',
  '#eee',
  '#e7e7e7'
];
const blackColor = '#000';
const whiteColor = '#FFF';
const blueColor = '#044296';
const lightBlueColor = '#259BC5';
const orangeColor = '#F68C16';

const boxShadow = {
  boxShadow:
    '0 10px 30px -12px rgba(' +
    hexToRgb(blackColor) +
    ', 0.42), 0 4px 25px 0px rgba(' +
    hexToRgb(blackColor) +
    ', 0.12), 0 8px 10px -5px rgba(' +
    hexToRgb(blackColor) +
    ', 0.2)'
};

const primaryBoxShadow = {
  boxShadow:
    '0 4px 20px 0 rgba(' +
    hexToRgb(blackColor) +
    ',.14), 0 7px 10px -5px rgba(' +
    hexToRgb(primaryColor[0]) +
    ',.4)'
};

const formLogin = {
  color: whiteColor,
  marginBottom: '30%'
};

const primaryCardHeader = {
  // background:
  //   "linear-gradient(60deg, " + primaryColor[1] + ", " + primaryColor[2] + ")",
  ...primaryBoxShadow
};

const cardStyles = {
  card: {
    border: '0',
    // marginBottom: "30px",
    borderRadius: '6px',
    color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
    width: '100%',
    // boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    fontSize: '.875rem',
    height: '100%'
  },
  cardBody: {
    padding: '0.9375rem 20px',
    flex: '1 1 auto',
    WebkitBoxFlex: '1',
    position: 'relative',
    paddingBottom: 20
  },
  cardBodyVars: {
    // maxWidth: "1920px",
    padding: '0.9375rem 0',
    flex: '1 1 auto',
    width: '100%',
    WebkitBoxFlex: '1',
    position: 'relative',
    margin: 'auto',
    overflow: 'auto',
    maxHeight: window.innerHeight - 100,
    height: '100%'
  },
  card100: {
    height: '100%'
  },
  jobsCorrection: {
    width: window.innerWidth < 900 ? window.innerWidth - 40 : ''
  }
};

// style={{
//   backgroundColor: "#ebebeb63",
//   boxShadow: "#00000040 1px 2px 2px",
//   border: "1px solid #11111114",
//   paddingLeft: 10,
//   paddingRight: 10
// }}

const colorAttributes = [
  '#269cff',
  '#269cff',
  '#55a4b9',
  '#55b984',
  '#70b955',
  '#dbd04b'
];

export {
  hexToRgb,
  //variables
  drawerWidth,
  transition,
  container,
  boxShadow,
  defaultFont,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  blackColor,
  whiteColor,
  primaryBoxShadow,
  primaryCardHeader,
  cardStyles,
  blueColor,
  colorAttributes,
  lightBlueColor,
  orangeColor
};
